import axios from "axios";
import { BASE_URL } from "../misc/Static_routes";
import { toast } from "react-toastify";
import axiosInstance from "../config/axiosConfig";
axios.defaults.withCredentials = true;

// REFACTOR: This need to be changed
const notify = (message) => toast.error(`${message}`, {});
const notifySuccess = (message) => toast.success(`${message}`, {});
const notifyError = (message) => toast.error(`${message}`, {});

export const getDesignByPinId = (pinId) => {
  const result = axios
    .get(`${BASE_URL}/api/pin/${pinId}/designs`)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });

  return result;
};

export const getDesignByPinIdInRange = (data) => {
  const result = axios
    .get(`${BASE_URL}/api/pin/${data.pinID}/designs/${data.offset}/${data.limit}`)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });

  return result;
};

export const getDesignById = (pinId, designId) => {
  const result = axios
    .get(`${BASE_URL}/api/pin/${pinId}/design/${designId}`)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });

  return result;
};

export const createDesign = async (data, t) => {
  const result = axios
    .post(`${BASE_URL}/api/pin/${data.pin_id}/designs`, data)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        notifySuccess(t('designCreated'));
        return response.data;
      } else {
        notifyError(t('errorWhileCreatingDesign'));
      }

      return result;
    });
};

export const deleteDesign = async (data) => {
  const result = axios
  .delete(`${BASE_URL}/api/designs`, {data})
  .then((response) => {
    const responseOK =
      response && response.status === 200 && response.statusText === "OK";
    if (responseOK) {
      notifySuccess(response?.data?.message);
      return response.data;
    }
  })
  .catch((err) => {
    notify(err?.response?.data?.message);
  });

  return result;
}

export const designService = {
  getDesignByPinIdInRange: (url) => axiosInstance.get(url)
}
